import { render, staticRenderFns } from "./OtherCountriesOfDoctorWork.vue?vue&type=template&id=46c928c8&"
import script from "./OtherCountriesOfDoctorWork.vue?vue&type=script&lang=ts&setup=true&"
export * from "./OtherCountriesOfDoctorWork.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./OtherCountriesOfDoctorWork.vue?vue&type=style&index=0&id=46c928c8&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46c928c8')) {
      api.createRecord('46c928c8', component.options)
    } else {
      api.reload('46c928c8', component.options)
    }
    module.hot.accept("./OtherCountriesOfDoctorWork.vue?vue&type=template&id=46c928c8&", function () {
      api.rerender('46c928c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/OtherCountriesOfDoctorWork.vue"
export default component.exports